export default "__VITE_ASSET__30bfd74b__"